"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var isFunction_1 = __importDefault(require("../shared/isFunction"));
var defaultOptions = {};
function useInput(initialValue, options) {
  if (initialValue === void 0) {
    initialValue = '';
  }
  if (options === void 0) {
    options = defaultOptions;
  }
  var _a = (0, react_1.useState)(initialValue),
    value = _a[0],
    setValue = _a[1];
  var onChange = (0, react_1.useCallback)(function (event) {
    var newValue = event.target.value;
    var shouldUpdate = true;
    if ((0, isFunction_1["default"])(options.validate)) {
      shouldUpdate = options.validate(newValue, value);
    }
    if (shouldUpdate) {
      setValue(newValue);
    }
  }, [options, value]);
  // sync with default value
  (0, react_1.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);
  var handler = {
    onChange: onChange,
    value: value
  };
  return handler;
}
exports["default"] = useInput;